import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Skeleton, InputBaseComponentProps } from '@mui/material';
import HypothesisValueInput from './HypothesisValueInput';

type FutureValueProps = {
    isLoading: boolean;
    typeValue: 'number' | 'percentage';
    disabled?: boolean;
    futureValue: number | undefined;
    onChange: (newValue: number | string) => void;
    inputProps: InputBaseComponentProps;
};

const HypothesisValue = ({
    futureValue,
    typeValue,
    disabled = false,
    onChange,
    inputProps,
    isLoading,
}: FutureValueProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Typography variant="body1" sx={{ fontSize: '10px' }}>
                {t('humanResources.simulation.futureValue')}
            </Typography>
            {isLoading ? (
                <Skeleton />
            ) : (
                <HypothesisValueInput
                    type={typeValue}
                    value={futureValue}
                    disabled={disabled}
                    handleInputChange={onChange}
                    inputProps={{
                        ...inputProps,
                    }}
                />
            )}
        </>
    );
};

export default memo(HypothesisValue);
